// angular
// 	.module("HeroPRO")
// 	.controller("UserController", userController);

import _ from 'lodash';
import './users.scss';

/* @ngInject */
export default function userController($scope, $rootScope, AccountsFactory, ModalService, ChangePasswordFactory, $timeout, UserData, $stateParams, $state, HPRoles, LicensesFactory) {
    const vm = this;

    vm.currentUser = {};
    vm.userProfile = {};
    vm.officesSubheader = '';
    vm.email = '';
    vm.confirmEmail = '';
    vm.phone = '';
    vm.phoneExt = '';
    vm.mobilePhone = '';
    vm.personalInfoStatusMessage = '';
    vm.passwordStatusMessage = '';
    vm.role = {};
    vm.enableDisableMessage = '';
    vm.preferencesStatusMessage = '';
    vm.enableDisableStatus = null;

    // Flags
    vm.isAdmin = false;
    vm.isEditUser = false;
    vm.isEditingProfile = false;
    vm.editPersonalInfoMode = false;
    vm.isPersonalInfoDirty = false;
    vm.isEditEmail = false;
    vm.isPersonalInfoError = false;
    vm.isPersonalInfoMessageDisplayed = false;
    vm.isPasswordErrorMessage = false;
    vm.changePasswordMode = false;
    vm.isPasswordMessageDisplayed = false;
    vm.isCompanyLevelUser = false; // Company Admin or Company Mgr
    vm.enableUserComplete = false;
    vm.changePreferencesMode = false;
    vm.isPreferencesError = false;
    vm.isLoggedInUserSalesRep = true;
    vm.submitted = 'false';

    init();

    /*= =======================================
   =            Public Functions            =
   ======================================== */

    vm.editPersonalinformation = function () {
        vm.editPersonalInfoMode = true;

        vm.user = {
            FirstName: vm.userProfile.FirstName,
            LastName: vm.userProfile.LastName,
            MiddleInitial: vm.userProfile.CSLBPersonnelMI,
            Suffix: vm.userProfile.CSLBPersonnelSuffix,
            Email: vm.userProfile.Email,
            PhoneNumber: vm.userProfile.Phone,
            Extension: vm.userProfile.PhoneExt,
            MobilePhone: vm.userProfile.MobilePhone,
            IsCSLBHolder: vm.userProfile.IsCSLBHolder,
            TitleId: vm.userProfile.CSLBTitleId,
            Licenses: vm.userProfile.Licenses === undefined ? new Array() : vm.userProfile.Licenses
        };
        console.log("user to edit", vm.user);
    };

    vm.cancelEditPersonalinformation = function () {
        resetUpdatePersonalInformation();
        vm.submitted = 'false';
        AccountsFactory.editProfileDirty = false;
    };

    vm.savePersonalinformation = function (isValid) {
        vm.submitted = 'true';
        if (isValid) {
            const user = {
                ContractorUserId: vm.userProfile.ContractorUserId,
                PhoneNumber: vm.user.PhoneNumber,
                MobilePhone: vm.user.MobilePhone,
                Email: vm.user.Email,
                Extension: vm.user.Extension,
                RoleId: vm.role.RoleId,
                Licenses: vm.user.Licenses
            };
            if (vm.user.licenseHolderSelected === true) {
                user.CSLBTitleId = vm.user.TitleId;
                user.CSLBMiddleInitial = vm.user.MiddleInitial;
                user.CSLBSuffix = vm.user.Suffix;
                user.FirstName = vm.user.FirstName;
            }
            savePersonalInformation(user);
        }
    };

    vm.changePreferences = function () {
        vm.changePreferencesMode = true;
        vm.userPreferences = {
            ContactByEmail: vm.userProfile.ContactByEmail
        };
    };

    vm.cancelChangePreferences = function () {
        vm.submitted = 'false';
        vm.changePreferencesMode = false;
    };

    vm.updateContactPreferences = function (user) {
        vm.submitted = 'true';
        AccountsFactory.updateContactPreferences({ ContractorUserId: vm.userProfile.ContractorUserId, ContactByEmail: user.ContactByEmail })
            .then((response) => {
                vm.userProfile.ContactByEmail = user.ContactByEmail;
                vm.changePreferencesMode = false;
            });
    };

    vm.addOfficeAssignment = function () {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/addOfficeAssignment/addOfficeAssignment.html',
            windowClass: 'add-office-assignment',
            controller: 'AddOfficeAssignmentController',
            controllerAs: 'addOfficeAssignment',
            size: 'full-screen',
            resolve: {
                currentUserProfile() {
                    return vm.userProfile;
                },
                signedInUserId() {
                    return vm.currentUser.ContractorUserId;
                },
            },
        });

        modal.result.then((addedoffice) => {
            if (addedoffice !== undefined) {
                // Add the office to the list of office assignments
                vm.userProfile.Locations.push(addedoffice);
            }
            ModalService.closeLgModal();
        });
    };


    vm.removeOfficeAssignment = function (office) {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/officeAssignments/removeOfficeAssignment.html',
            windowClass: 'remove-office-assignment',
            controller: 'RemoveOfficeAssignmentController',
            controllerAs: 'removeOfficeAssignment',
            size: 'full-screen',
            resolve: {
                selectedOffice() {
                    return office;
                },
                contractorUserId() {
                    return vm.userProfile.ContractorUserId;
                },
            },
        });

        modal.result.then((result) => {
            if (result === true) {
                // Remove the office from the list of office assignments
                vm.userProfile.Locations = _.without(vm.userProfile.Locations, office);
            }
            ModalService.closeLgModal();
        });
    };

    vm.changePassword = function () {
        vm.changePasswordMode = true;
        ChangePasswordFactory.changePasswordEnable = true;
        ChangePasswordFactory.userObj = vm.userProfile;
    };

    vm.requestPassword = function () {
        sendForgotPasswordEmail(vm.userProfile.Email);
    };

    vm.backToUsers = function () {
        vm.isEditUser = false;
        $state.go('accounts', { accountsPage: 'users', accountId: null });
    };

    vm.disableUser = function () {
        vm.enableDisableStatus = 3;
        AccountsFactory.disableUser({ ContractorUserId: vm.userProfile.ContractorUserId }).then((response) => {
            if (response.data.Data === vm.userProfile.ContractorUserId) {
                vm.userProfile.isEnabled = false;
                vm.enableDisableStatus = 0;
                vm.enableDisableMessage = 'This user is currently disabled.';
                vm.enableUserComplete = false;
            }
        });
    };

    vm.enableUser = function () {
        vm.enableDisableStatus = 1;
        AccountsFactory.enableUser({ ContractorUserId: vm.userProfile.ContractorUserId }).then((response) => {
            if (response.data.Data === vm.userProfile.ContractorUserId) {
                vm.userProfile.isEnabled = true;
                vm.enableDisableStatus = 2;
                vm.enableDisableMessage = 'This user is now enabled.';
                $timeout(() => {
                    vm.enableUserComplete = true;
                }, 5000);
            }
        });
    };

    vm.deleteUser = function () {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/deleteUser/deleteUser.html',
            windowClass: 'delete-user',
            controller: 'DeleteUserController',
            controllerAs: 'deleteUser',
            size: 'full-screen',
            resolve: {
                selectedUser() {
                    return vm.userProfile;
                },
            },
        });

        modal.result.then((result) => {
            if (result === true) {
                // If user is successfully deleted, take the user to the users page
                $state.go('accounts', { accountsPage: 'users', accountId: null });
            }
            ModalService.closeLgModal();
        });
    };

    vm.showContractorUserLicense = function () {
        return vm.hasCaliforniaLocation || (vm.userProfile && vm.userProfile.Licenses) || (vm.user && vm.user.Licenses);
    };

    vm.canEditContractorUserLicense = function () {
        // Users cannot edit the HIS of other users
        return vm.userProfile.ContractorUserId === vm.currentUser.ContractorUserId;
    };

    vm.openContractorUserLicenseRegistrationModal = function () {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicenseRegistration.html',
            windowClass: 'contractor-user-license-registration',
            controller: 'ContractorUserLicenseRegistrationController',
            controllerAs: 'contractorUserLicenseRegistration',
            size: 'full-screen',
            resolve: {
                selectedUser() {
                    return undefined;
                },
            },
        });

        modal.result.then((result) => {
            if (result) {
                console.log("Contractor License Registration result", result);
                vm.user.Licenses.push(result);
            }
            ModalService.closeLgModal();
        });
    }
    /* -----  End of Public Functions  ------*/

    /*= =======================================
   =            Private Functions            =
   ======================================== */
    function init() {
        getContractorUser();
        vm.isPasswordMessageDisplayed = false;
        vm.changePasswordMode = false;
        ChangePasswordFactory.changePasswordEnable = false;
        resetUpdatePersonalInformation();
        enableBackLink();
        setProfileFlag();
        getOrganizationLicense();
    }

    function getOrganizationLicense() {
        // Find the california license
        LicensesFactory.getLicenses().then((response) => {
            const californiaLicense = _.findWhere(response.data.Data.Licenses, { OrganizationLicenseTypeId: 1 });
            if (californiaLicense !== undefined) {
                vm.licenseNumber = californiaLicense.LicenseNumber;
            }
        });
    }

    function getContractorUser() {
        AccountsFactory.getContractorUser($stateParams.accountId).then((response) => {
            if (response.data.Data !== undefined || response.data.Data !== null) {
                vm.userProfile = response.data.Data;
                vm.hasCaliforniaLocation = _.findWhere(vm.userProfile.Locations, { State: 'CA' }) !== undefined;
                vm.role = vm.userProfile.Roles[0];
                getUserPermissions();
                buildOfficesSubheader();
                initializeUserState();
            }
        });
    }

    function buildOfficesSubheader() {
        if (vm.userProfile.Locations.length > 1) {
            vm.officesSubheader = 'Office Assignments';
        } else {
            vm.officesSubheader = 'Office Assignment';
        }
    }

    function initializeUserState() {
        if (vm.userProfile.isEnabled === true) {
            vm.enableDisableStatus = 2;
            vm.enableUserComplete = true;
        } else {
            vm.userProfile.isEnabled = false;
            vm.enableDisableStatus = 0;
            vm.enableDisableMessage = 'This user is currently disabled';
            vm.enableUserComplete = false;
        }
    }

    function savePersonalInformation(user) {
        AccountsFactory.updateContractorUser(user).then((response) => {
            if (response.data.ResultCode === 2) {
                $rootScope.$broadcast('EmailInUse');
            } else if (response.data.ResultCode === 1) {
                const result = response.data.Data;
                vm.errorMessage = '';
                vm.userProfile.FirstName = result.FirstName;
                vm.userProfile.CSLBPersonnelMI = result.CSLBMiddleInitial;
                vm.userProfile.CSLBPersonnelSuffix = result.CSLBSuffix;
                vm.userProfile.CSLBTitleId = result.CSLBTitleId;
                vm.userProfile.IsCSLBHolder = result.IsValidOfficer;
                vm.userProfile.Email = result.Email;
                vm.userProfile.Phone = result.Phone;
                vm.userProfile.PhoneExt = result.PhoneExt;
                vm.userProfile.MobilePhone = result.MobilePhone;
                vm.userProfile.Roles[0] = vm.role;
                vm.userProfile.Licenses = result.Licenses;
                resetUpdatePersonalInformation();
                $rootScope.$broadcast('CSLB-Qualifier-Fixed');
            }
        });
    }

    function resetUpdatePersonalInformation() {
        vm.editPersonalInfoMode = false;
        vm.isEditEmail = false;
        vm.isEmailConfirmed = false;
        vm.email = '';
        vm.confirmEmail = '';
        vm.phone = '';
        vm.phoneExt = '';
        vm.mobilePhone = '';
        vm.personalInfoStatusMessage = '';
        vm.isPersonalInfoError = false;
        //		AccountsFactory.setEditProfileDirtyFlag(false);
    }

    function enableBackLink() {
        if ($stateParams.accountId !== null) {
            vm.isEditUser = true;
        } else {
            vm.isEditUser = false;
        }
    }

    function sendForgotPasswordEmail(email) {
        ChangePasswordFactory.requestRecoverPasswordEmail(email).then((response) => {
            if (response.data.Result || response.data.Data) {
                ChangePasswordFactory.statusMessage = `We've sent a reset password link to ${vm.userProfile.Email}`;
            }
        });
    }

    function getUserPermissions() {
        UserData.getUserData().then((response) => {
            vm.currentUser = response;
            vm.isAdmin = vm.currentUser.HasElevatedAccess;
            vm.isLoggedInUserSalesRep = (HPRoles[vm.currentUser.Roles[0]].rank === 3);
            vm.isProfileView = ($stateParams.accountId === null || $stateParams.accountId === undefined);
            userProfileCheck();
        });

        if (vm.role.RoleId === HPRoles.COPO_COMPANY_ADMIN.roleId || vm.role.RoleId === HPRoles.COPO_COMPANY_MGR.roleId) {
            vm.isCompanyLevelUser = true;
        }
    }


    function userProfileCheck() {
        if (($stateParams.accountId !== null || $stateParams.accountId !== undefined) && vm.currentUser.ContractorUserId === Number($stateParams.accountId)) {
            $state.go('accounts', { accountsPage: 'myprofile', accountId: null });
        }
    }

    function setProfileFlag() {
        if ($stateParams.accountId === null || $stateParams.accountId === undefined) {
            vm.isEditingProfile = true;
        } else {
            vm.isEditingProfile = false;
        }
    }

    $rootScope.$watch(() => AccountsFactory.statusMessage, (value) => {
        if (value !== undefined && value !== '') {
            vm.passwordStatusMessage = value;
            vm.isPasswordMessageDisplayed = true;
            $timeout(() => {
                vm.isPasswordMessageDisplayed = false;
                ChangePasswordFactory.statusMessage = '';
            }, 5000);
        }
    });

    $scope.$on('editPersonalInfo', (event, payload) => {
        vm.editPersonalInfoMode = payload.isEdit;
    });

    $rootScope.$watch(() => ChangePasswordFactory.changePasswordEnable, (value) => {
        if (value !== vm.changePasswordMode) {
            vm.changePasswordMode = value;
        }
    });

    $rootScope.$watch(() => ChangePasswordFactory.statusMessage, (value) => {
        if (value !== '') {
            vm.passwordStatusMessage = value;
            vm.isPasswordMessageDisplayed = true;
            $timeout(() => {
                vm.isPasswordMessageDisplayed = false;
                ChangePasswordFactory.statusMessage = '';
            }, 5000);
        }
    });
}



// WEBPACK FOOTER //
// ./src/app/accounts/user/userController.js